<template>
    <div class="past-promotioms-checkbox-renderer">
        <v-checkbox v-model="value" class="rtls-checkbox" @update:model-value="setSelected" />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import parkingLotStates from '@enums/parking-lot-states';

export default defineComponent({
    data() {
        return {
            parkingLotStates,
            value: false,
        };
    },
    mounted() {
        this.value = this.params.node.isSelected();
        this.emitter.on('selectAllChanged', this.selectAllHandler);
    },
    beforeUnmount() {
        this.emitter.off('selectAllChanged', this.selectAllHandler);
    },
    methods: {
        setSelected(value) {
            this.params.node.setSelected(value);
        },
        selectAllHandler(param) {
            this.params.node.setSelected(param);
            this.value = param;
        },
    },
});
</script>

<style lang="scss" scoped>
.past-promotioms-checkbox-renderer {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
